import { RouteObject } from "react-router-dom";
import { DevelopmentScopeTemplatePage } from "src/routes/developments/templates/DevelopmentScopeTemplatePage";
import { DevelopmentScopeTemplatesPage } from "src/routes/developments/templates/DevelopmentScopeTemplatesPage";
import { ScopeTemplateCostCalculatorPage } from "src/routes/developments/templates/ScopeTemplateCostCalculatorPage";
import * as templatesPaths from "src/routing/domains/developments/templates/templatesPaths";

/**
 * SideNav leaf routes for development scope-templates section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in `detail/developmentDetail.tsx`.
 * The templates list lives on the Beam branch (`templatesBeamSideNavRoutes`).
 */
export const templatesSideNavRoutes: RouteObject[] = [
  { path: templatesPaths.developmentScopeTemplateCostReportRoute.path, Component: ScopeTemplateCostCalculatorPage },
  { path: templatesPaths.developmentScopeTemplateRoute.path, Component: DevelopmentScopeTemplatePage },
];

/**
 * Templates leaves that have migrated to Beam's SideNavLayout and document-scroll page layouts.
 *
 * Role: data router domain leaves. Spread under `DevelopmentBeamSideNavLayout` in
 * `detail/developmentDetail.tsx`.
 */
export const templatesBeamSideNavRoutes: RouteObject[] = [
  { path: templatesPaths.developmentScopeTemplatesRoute.path, Component: DevelopmentScopeTemplatesPage },
];
